import axios from './axios'
import Vue from 'vue'
import { Message } from 'element-ui'


Vue.prototype.$axios = axios

Vue.prototype.$success = text => {
  Message({
    showClose: true,
    message: text,
    type: 'success'
  })
}

Vue.prototype.$fail = text => {
  Message({
    showClose: true,
    message: text,
    type: 'error'
  })
}

//全局绑定事件处理
const VueBus = new Vue();
Vue.prototype.$bus = {
  $vueBus:VueBus,
  $on(...event) {
    VueBus.$on(...event);
  },
  $off(...event) {
    VueBus.$off(...event);
  },
  $once(...event) {
    VueBus.$once(...event);
  },
  $emit(...event) {
    VueBus.$emit(...event);
  },
  $has(event) {
    if (VueBus._events[event]) {
      return true;
    }
    return false;
  }
};

Vue.prototype.$ossUrl = "https://modelwiser-linked-1256356146.piccd.myqcloud.com/"
